<template>
  <div>
    <h3>Puzzle</h3>

    <hivey-button v-model="target" class="target"></hivey-button>

    <br />
    <br />

    <hivey-button v-model="tl"></hivey-button>
    <hivey-button v-model="tm"></hivey-button>
    <hivey-button v-model="tr"></hivey-button>
    <br />
    <hivey-button v-model="ml"></hivey-button>
    <hivey-button v-model="mm"></hivey-button>
    <hivey-button v-model="mr"></hivey-button>
    <br />
    <hivey-button v-model="bl"></hivey-button>
    <hivey-button v-model="bm"></hivey-button>
    <hivey-button v-model="br"></hivey-button>

    <h3>Solution</h3>
    <p>(shoot each tile the indicated number of times; the order doesn't matter)</p>

    <table v-if="solution">
      <tr>
        <td>{{ solution[0] }}</td>
        <td>{{ solution[1] }}</td>
        <td>{{ solution[2] }}</td>
      </tr>
      <tr>
        <td>{{ solution[3] }}</td>
        <td>{{ solution[4] }}</td>
        <td>{{ solution[5] }}</td>
      </tr>
      <tr>
        <td>{{ solution[6] }}</td>
        <td>{{ solution[7] }}</td>
        <td>{{ solution[8] }}</td>
      </tr>
    </table>
    <p v-else>
      No solution found!
    </p>
  </div>
</template>

<script>
import data from './data/data.json'
import HiveyButton from './components/HiveyButton.vue'

export default {
  components: {
    HiveyButton
  },

  data () {
    return {
      target: 0,
      tl: 0,
      tm: 0,
      tr: 0,
      ml: 0,
      mm: 0,
      mr: 0,
      bl: 0,
      bm: 0,
      br: 0
    }
  },

  computed: {
    solution () {
      function mod (x, n) {
        return ((x % n) + n) % n
      }

      const diff = [this.tl, this.tm, this.tr, this.ml, this.mm, this.mr, this.bl, this.bm, this.br].map((k) => mod(this.target - k, 4))

      return data[diff.join('')]
    }
  }
}
</script>

<style scoped>
.target {
  margin-left: 50px;
}

table {
  border-collapse: collapse;
}

td {
  border: 1px solid black;
  width: 50px;
  height: 50px;
  text-align: center;
}
</style>
